import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import { createNewBlog, fetchBlogList, fetchEditBlog } from "../actions/blog";
import { useNavigate, useParams } from "react-router-dom";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const UploadField = ({
  handleFileChange,
  placeholder,
  fieldName,
  className,
}) => {
  return (
    <div className={className}>
      <label>
        <input
          className="test-test"
          id={`file-input-${fieldName}`}
          name={fieldName}
          accept={".jpg,.png"}
          multiple={false}
          type="file"
          hidden
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          component="span"
          className="default-btn-primary"
          size="small"
          startIcon={<FileUploadRoundedIcon />}
        >
          {placeholder}
        </Button>
      </label>
    </div>
  );
};

const BlogAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  //breadcrumb
  const translateForm = "blogForm";
  const translateModule = "blog";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    countryId: "",
    description: "",
    status: "ACTIVE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState(null);

  const { blogDetail } = useSelector((state) => state.blogReducer);

  const { countryFormList } = useSelector((state) => state.countryReducer);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));
    }
  }, [countryFormList]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchBlogList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (blogDetail && id) {
      setData({
        ...data,
        name: blogDetail.name || initialState.name,
        description: blogDetail.description || initialState.description,
        image: blogDetail.image || initialState.image,
        countryId: blogDetail.countryId || initialState.countryId,
        status: blogDetail.status || initialState.status,
        createdAt: blogDetail.createdAt || "",
        updatedAt: blogDetail.updatedAt || "",
      });
    }
  }, [blogDetail, id, dispatch]);

  const clientValidationHandler = () => {
    const { name, countryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }
    const formData = new FormData();

    formData.append("image", image);
    formData.append("name", data.name);
    formData.append("description", data.description);
    formData.append("countryId", data.countryId);
    formData.append("status", data.status);

    if (id) {
      formData.append("id", id);
      dispatch(fetchEditBlog(formData, navigate));
    } else {
      if (!image) {
        toast.error("Morate odabrati sliku", { theme: "colored" });
        return;
      }
      dispatch(createNewBlog(formData, navigate));
    }
  };

  const handleFileDelete = (fieldName) => {
    switch (fieldName) {
      case "image":
        setImage(null);
      default:
        break;
    }

    // Resetovanje input polja
    //TODO: Ispraviti da ide preko refa
    document.getElementById(`file-input-${fieldName}`).value = "";
  };

  const handleFileChange = (event) => {
    const name = event.target.name;
    const selectedFile = event.target.files[0];
    if (
      (selectedFile && selectedFile.type === "image/jpeg") ||
      selectedFile.type === "image/png"
    ) {
      switch (name) {
        case "image":
          setImage(selectedFile);
          break;
        default:
          return;
      }
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
        extraTitle={blogDetail && blogDetail.name}
      />
      <Container className="blog-container">
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Card>
                    <Card.Header>
                      <FormTitleMain />
                    </Card.Header>
                    <Card.Body>
                      <div className="blog-holder-admin-left-side-text">
                        <Row>
                          <Col lg={8} md={12} xs={12} className="mb-4">
                            <InputField
                              label={t("blogForm.name")}
                              name="name"
                              value={data.name}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-3">
                            <FormControl
                              fullWidth
                              size="small"
                              required
                              error={errors.countryId}
                              disabled={countryFormList?.length === 1}
                            >
                              <InputLabel id="demo-simple-select-label">
                                {t("blogForm.country")}
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.countryId}
                                label={t("blogForm.country")}
                                name="countryId"
                                onChange={handleInputChange}
                                size="small"
                              >
                                {countryFormList?.map((item, key) => (
                                  <MenuItem value={item.id} key={key}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>

                              {errors?.countryId && (
                                <FormHelperText>
                                  {t("blogForm.requiredField")}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Col>
                          <Col lg={12} md={12} xs={12} className="mb-4">
                            <CKEditor
                              name="description"
                              editor={Editor}
                              data={data.description}
                              onReady={(editor) => {}}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setData((prevData) => ({
                                  ...prevData,
                                  description: data,
                                }));
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t("awardForm.image")}</Card.Header>
                        <Card.Body>
                          <UploadField
                            handleFileChange={handleFileChange}
                            placeholder={t("awardForm.imagePlaceholder")}
                            fieldName={"image"}
                          />
                          {data.image && (
                            <Col lg={12} md={12} xs={12}>
                              <Fragment>
                                <div className="preview-image-holder-admin">
                                  <img
                                    src={data.image}
                                    alt={data.image?.name}
                                    width={`100%`}
                                  />
                                </div>
                              </Fragment>
                            </Col>
                          )}

                          {image && (
                            <Fragment>
                              <div className="mt-2">
                                {t("awardForm.imageChoosen")}:{" "}
                                <b>{image?.name}</b> ({t("awardForm.imageSize")}
                              </div>
                              <div className="preview-image-holder-admin mt-2">
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt={image?.name}
                                  width={`100%`}
                                />
                              </div>
                              <div className="text-end mt-2">
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => handleFileDelete("image")}
                                >
                                  {t("awardForm.imageRemove")}
                                </Button>
                              </div>
                            </Fragment>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default BlogAdd;
